import { useUser } from "../functional-components/UserContext";

const useShowPricesWithVat = () => {
  const { b2b } = useUser();
  return !b2b;
};

export default useShowPricesWithVat;
